import { create } from 'zustand';

// Ephemeral UI signal that lets "Reset all filters" (in the table toolbar)
// clear the map's "Search a place" text input — which is local, uncontrolled
// state inside `MapSearchControl`, not a URL param (a place pick only flies the
// map, it doesn't write a filter). The table calls `reset()`, bumping `token`;
// the map panel keys the search control on `token` so it remounts with empty
// text. Session-only, not persisted (see state-boundaries.md).
type MapSearchResetStore = {
  token: number;
  reset: () => void;
};

export const useMapSearchResetStore = create<MapSearchResetStore>((set) => ({
  token: 0,
  reset: () => set((state) => ({ token: state.token + 1 })),
}));
